import React from 'react';
import { Clock, Truck, Zap, Sparkles } from 'lucide-react';
import ReservationForm from './ReservationForm';
import { BRAND } from '../mock';

const Hero = () => {
  return (
    <section id="home" className="relative overflow-hidden hero-gradient">
      {/* Bubbles */}
      <div className="bubble hidden md:block" style={{ width: 220, height: 220, top: -60, left: -40 }} />
      <div className="bubble hidden md:block" style={{ width: 140, height: 140, top: 200, right: 40, opacity: 0.6 }} />
      <div className="bubble hidden md:block" style={{ width: 90, height: 90, bottom: 80, left: '40%', opacity: 0.5 }} />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 lg:py-24 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="reveal in">
          <div className="inline-flex items-center gap-2 bg-white border border-[color:var(--brand)]/20 rounded-full px-4 py-1.5 mb-6 shadow-sm">
            <Sparkles className="w-4 h-4 text-[color:var(--brand)]" />
            <span className="text-xs font-semibold tracking-wide text-[color:var(--ink)]">Bersih • Wangi • Higienis</span>
          </div>

          <h1 className="font-display text-[34px] sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] text-[color:var(--ink)]">
            No.1 <span className="text-[color:var(--brand)]">Laundry Express</span> <br className="hidden sm:block" /> Terpercaya
          </h1>

          <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-xl">
            <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[color:var(--brand-50)] shadow-sm">
              <Clock className="w-5 h-5 text-[color:var(--brand)] flex-shrink-0" />
              <div>
                <div className="text-[11px] text-[color:var(--muted)]">Quick</div>
                <div className="font-bold text-sm">4 Jam</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[color:var(--brand-50)] shadow-sm">
              <Zap className="w-5 h-5 text-[color:var(--brand)] flex-shrink-0" />
              <div>
                <div className="text-[11px] text-[color:var(--muted)]">Express</div>
                <div className="font-bold text-sm">1 Hari</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[color:var(--brand-50)] shadow-sm">
              <Truck className="w-5 h-5 text-[color:var(--brand)] flex-shrink-0" />
              <div>
                <div className="text-[11px] text-[color:var(--muted)]">Pickup Delivery*</div>
                <div className="font-bold text-sm">GRATIS</div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href="#services" className="btn-brand">Lihat Layanan</a>
            <a href={BRAND.whatsapp} target="_blank" rel="noreferrer" className="btn-brand-outline">Hubungi Kami</a>
          </div>

          <p className="mt-6 text-sm text-[color:var(--muted)]">Melayani area Jakarta Selatan dan sekitarnya — antar jemput cepat dari outlet kami di Apartemen Kebagusan City.</p>
        </div>

        <div className="reveal in">
          <ReservationForm />
        </div>
      </div>

      <svg className="block w-full" viewBox="0 0 1440 80" preserveAspectRatio="none" style={{ height: 60 }} aria-hidden="true">
        <path d="M0 40 C240 80 480 0 720 30 C960 60 1200 10 1440 40 L1440 80 L0 80 Z" fill="#ffffff" />
      </svg>
    </section>
  );
};

export default Hero;
